import { render, staticRenderFns } from "./NumberBadge.vue?vue&type=template&id=76bbf20b&scoped=true&"
import script from "./NumberBadge.vue?vue&type=script&lang=js&"
export * from "./NumberBadge.vue?vue&type=script&lang=js&"
import style0 from "./NumberBadge.vue?vue&type=style&index=0&id=76bbf20b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bbf20b",
  null
  
)

export default component.exports